import { parseOrRaw } from 'domain/shared/validation'
import { conversionGoalsResponseSchema } from './schemas'

// parseOrRaw falls through to the raw response on schema mismatch rather than
// breaking the selector.
export function mapConversionGoalsResponse(data) {
  const source = parseOrRaw(conversionGoalsResponseSchema, data) ?? {}

  return {
    conversionTracking: source.conversion_tracking ?? null,
    selectionMode: source.selection_mode ?? null,
    goals: source.goals ?? [],
    warnings: source.warnings ?? [],
    meta: source.meta ?? {},
  }
}
